import { all, fork } from 'redux-saga/effects'
import { Auth, i18n, Preloader, Firebase, Timer, SavePoint, Game } from './Core'

import * as mars from './Mars/mars.sagas'

import * as tutorial from './Tutorial/tutorial.sagas'

/**
 *  Main saga entry point
 *  Here we import the sagas for every module in the application
 */
export default function* rootSaga() {
  yield all([
    // Save Point sagas should be the first to allow all other sagas to use it
    fork(SavePoint.sagas.sagas),

    // Here comes the sagas of each module
    fork(mars.sagas),
    fork(i18n.sagas.sagas),
    fork(Preloader.sagas.sagas),
    fork(Firebase.sagas.sagas),
    fork(Timer.sagas.sagas),
    fork(Game.statusChecker.sagas),
    fork(tutorial.sagas),

    // must be here because all other modules register components inside game
    // module.
    fork(Game.sagas.sagas),
    // must be the last because this saga start the game initialization
    fork(Auth.sagas.sagas),
  ])
}
